export interface StudentInfo {
  id: string
  fullName: string
}

export function defaultStudentInfo(): StudentInfo {
  return {
    id: '',
    fullName: ''
  }
}
